import { closeModal } from "../stores/useModalStore";

export default function Modal(props: React.PropsWithChildren) {
  const { children } = props;

  const handleClose = (evt: React.MouseEvent) => {
    evt.preventDefault();
    closeModal();
  };

  return (
    <div className="modal">
      <button className="close-modal" onClick={handleClose}>
        Close
      </button>
      {children}
    </div>
  );
}
